export function MiniProgramPage() {
    return (
        <div>
            <h1 className="mb-2 text-xl text-green-700">小程序</h1>

            <div className="my-4">网页版与小程序数据互通</div>

            <div className="my-4">扫码进入</div>
            <div className="w-80">
                <img
                    src="https://assets.riyu.love/images/mini_program_qr_code.jpg"
                    alt="日语轻松考"
                />
            </div>
        </div>
    )
}
